import type { Product } from '@/lib/types/Product'

export async function loadProduct(handle: string): Promise<Product> {
  return await fetch(`/products/${handle}?view=json-endpoint`).then((res) =>
    res.json(),
  )
}
